import { render, staticRenderFns } from "./ConfirmedForm.vue?vue&type=template&id=36d1da08&scoped=true&"
import script from "./ConfirmedForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d1da08",
  null
  
)

export default component.exports